module.exports = __webpack_public_path__ + "static/media/change-password.9ea4a2df.png";